import { Observable } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

import {
  makeStateKey,
  StateKey,
  TransferState
} from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { APP_VERSION } from './version/app-version';
import { EnvService } from './env.service';

export class TranslateBrowserLoader implements TranslateLoader {
  constructor(private http: HttpClient, private transferState: TransferState, @Inject(APP_VERSION) private appVersion: string, private  envService: EnvService) {}

  private prefix = "/assets/i18n/";
  private suffix = ".json";


  public getTranslation(lang: string): Observable<any> {
    const key: StateKey<number> = makeStateKey<number>(
      'transfer-translate-' + lang
    );
    const data = this.transferState && this.transferState.get(key, null);//TODO temp

    // First we are looking for the translations in transfer-state, 
	// if none found, http load as fallback
    if (data) {
      return new Observable((observer) => {
        observer.next(data);
        observer.complete();
      });
    } else {

      const prefix = this.envService.appVersion == 'dev' ? this.prefix : `${this.prefix}${this.envService.appVersion}/`;

      return new TranslateHttpLoader(this.http, prefix, this.suffix).getTranslation(lang);
    }
  }
}

export function translateBrowserLoaderFactory(
  httpClient: HttpClient,
  transferState: TransferState,
  appVersion: string,
  envService: EnvService
) {
  return new TranslateBrowserLoader(httpClient, transferState, appVersion, envService);
}